import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';

export const CreateWirePaymentMethodDtoSchema = z
    .object({
        buyerId: z.string().regex(/^[0-9a-f]{24}$/i, 'Invalid buyer ID format'),
        currencies: z.array(EnumSchema(Currency)).min(1, 'At least one currency is required'),
    })
    .strict()
    .openapi({
        title: 'CreateWirePaymentMethodDto',
    });

export class CreateWirePaymentMethodDto extends FromSchema(CreateWirePaymentMethodDtoSchema) {
    buyerId: string;
    currencies: Currency[];
}
